import React from 'react';
import PropTypes from 'prop-types';
import JSXStyle from 'styled-jsx/style';

export default function DividerComponent({ component, style }) {
	const { id } = component;

	const { css, margin } = getStyle(style, component.style, id);

	return (
		<div style={{ marginBottom: margin, marginTop: margin, width: '100%' }}>
			<hr className={`jsx-${id}`} />
			<JSXStyle id={id}>{css}</JSXStyle>
		</div>
	);
}

DividerComponent.propTypes = {
	component: PropTypes.object,
	style: PropTypes.object,
	dividersStyles: PropTypes.object,
};

function getStyle(style, id, componentID) {
	const dividerStyle = style['divider'];
	const styles = style['dividers'];
	let color =
		!!dividerStyle && !!dividerStyle['color']
			? `#${dividerStyle['color'].replace('#', '')}`
			: 'black';
	const margin =
		!!dividerStyle && !!dividerStyle['margin']
			? `${dividerStyle['margin']}px`
			: 0;

	const response = {
		margin,
		css: `hr.jsx-${componentID}{
			border-bottom: 1px solid ${color};
		}`,
	};

	let overwriteStyle = null;

	for (const k in styles) {
		const s = styles[k];
		if (s.id === id) {
			overwriteStyle = s;
			break;
		}
	}

	if (!overwriteStyle) {
		return response;
	}

	if (overwriteStyle.divider_style) {
		switch (overwriteStyle.divider_style) {
			case 'blur':
				response.css = `hr.jsx-${componentID} {
					height: 0;
					box-shadow: 0 0 10px 1px ${color};
				}
				hr:after.jsx-${componentID}{
					content: "\\00a0";
				}`;
				break;
			case 'dashed':
				response.css = `hr.jsx-${componentID} {
					border-bottom: 1px dashed ${color};
				}`;
				break;
			case 'chapter':
				response.css = `hr.jsx-${componentID} {
						padding: 0;
						border-top: medium double ${color};
						color: ${color};
						text-align: center;
					}
					hr:after.jsx-${componentID} {
						content: "§";
						display: inline-block;
						position: relative; 
						top: -0.7em;  
						font-size: 1.5em;
						padding: 0 0.25em;
					}`;
				break;
			case 'elegant':
				response.css = `hr.jsx-${componentID} {
					height: 20px;
					border-style: solid;
					border-color: ${color};
					border-width: 1px 0 0 0;
					border-radius: 20px;
				}
				hr:before.jsx-${componentID} {
					display: block;
					content: "";
					height: 20px;
					margin-top: -21px;
					border-style: solid;
					border-color: ${color};
					border-width: 0 0 1px 0;
					border-radius: 20px;
				}`;
				break;
			case 'innerfade':
				response.css = `hr.jsx-${componentID} {
					height: 2px;
					background: ###color#;
					background-image: -webkit-linear-gradient(left, #fff, ${color}, #fff);
					background-image: linear-gradient(left, #fff, ${color}, #fff);
				}`;
				break;
			case 'inset':
				response.css = `hr.jsx-${componentID} {
					height: 0;
					border-top: 1px solid rgba(0, 0, 0, 0.1);
					border-bottom: 1px solid rgba(255, 255, 255, 0.3);
				}`;
				break;
			case 'shadow':
				response.css = `hr.jsx-${componentID} {
					height: 12px;
      				box-shadow: inset 0 10px 12px -12px rgba(0,0,0,0.5);
				}`;
				break;
			default:
				response.css = `hr.jsx-${componentID}{
					border-bottom: 1px solid ${color};
				}`;
		}
	}

	return response;
}
